import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Client-side pagination hook. Clamps the page when the list shrinks (e.g. after filtering).
export function usePaged(items, perPage) {
  const [page, setPage] = useState(1);
  const list = items || [];
  const pageCount = Math.max(1, Math.ceil(list.length / perPage));
  useEffect(() => {
    if (page > pageCount) setPage(1);
  }, [pageCount, page]);
  const pageItems = list.slice((page - 1) * perPage, page * perPage);
  return { page, setPage, pageCount, pageItems };
}

export function Paginator({ page, pageCount, onPage, testid = "paginator" }) {
  if (!pageCount || pageCount <= 1) return null;
  const nums = [];
  const win = 1;
  for (let i = 1; i <= pageCount; i++) {
    if (i === 1 || i === pageCount || (i >= page - win && i <= page + win)) nums.push(i);
    else if (nums[nums.length - 1] !== "…") nums.push("…");
  }
  const Btn = ({ disabled, onClick, children, active, tid }) => (
    <button
      type="button"
      data-testid={tid}
      disabled={disabled}
      onClick={onClick}
      className="min-w-9 h-9 px-3 inline-flex items-center justify-center rounded-full text-sm font-semibold border transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      style={active
        ? { background: "var(--sj-primary)", color: "#fff", borderColor: "var(--sj-primary)" }
        : { background: "#fff", color: "var(--sj-text-2)", borderColor: "var(--sj-border)" }}
    >
      {children}
    </button>
  );
  return (
    <div className="flex items-center justify-center gap-1.5 flex-wrap pt-4" data-testid={testid}>
      <Btn tid={`${testid}-prev`} disabled={page <= 1} onClick={() => onPage(page - 1)}><ChevronLeft className="h-4 w-4" /></Btn>
      {nums.map((n, i) => n === "…"
        ? <span key={`e${i}`} className="px-1.5" style={{ color: "var(--sj-text-3)" }}>…</span>
        : <Btn key={n} tid={`${testid}-page-${n}`} active={n === page} onClick={() => onPage(n)}>{n}</Btn>)}
      <Btn tid={`${testid}-next`} disabled={page >= pageCount} onClick={() => onPage(page + 1)}><ChevronRight className="h-4 w-4" /></Btn>
    </div>
  );
}
